import mixpanel from 'mixpanel-browser';
import Config from './config';

mixpanel.init(Config.mixpanel.token);


let env_check = true;

let actions = {
  identify: (id) => {
    if (env_check) mixpanel.identify(id);
  },
  alias: (id) => {
    if (env_check) mixpanel.alias(id);
  },
  track: (name, props) => {
    if (env_check) mixpanel.track(name, props);
  },
  people: {
    set: (props) => {
      if (env_check) mixpanel.people.set(props);
    },
  },
};

export let Mixpanel = actions;


// WEBPACK FOOTER //
// ./src/mixpanel.js